<script>
  import { fade, slide } from "svelte/transition";
  import { isLoggedIn, isAdminUser, getQuestionnaireProgress, getData, handleLogout, getQuestionnaire } from "../utility.js";
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";

  export let sidebarVisible;
  let loggedIn = false;
  let isAdmin = false;
  let progress = 0;
  let categories = [];

  function handleKeyDown(event) {
      if (event.key === "Escape") {
          closeSidebar();
      }
  }

  onMount(async () => {
      loggedIn = await isLoggedIn();
      if (loggedIn) {
        isAdmin = await isAdminUser();
        let data = await getQuestionnaireProgress();
        progress = data.highest_available_category || 0;

        data = await getQuestionnaire();
        categories = data.categories;

        categories = categories.filter(category => category.category_name !== "Feedback");
      }
  });

  function navigateTo(url) {
      if (window.location.hash !== url) {
          push(url);
      } else {
          window.location.reload();
      }
  }
</script>

{#if sidebarVisible}
<div class="fixed flex top-[56px] left-0 z-30">
  <div class="bg-white h-screen w-52 p-4" in:slide={{ axis: 'x' }} out:slide={{ axis: 'x' }}>
      <div class="p-4 flex flex-col gap-3">
          <a href="/#/" class="text-lg font-semibold" on:click={() => navigateTo('/#/')}>Startseite</a>
          <a href="/#/questionnaire" class="text-lg font-semibold" on:click={() => navigateTo("/#/questionnaire")}>Fragebogen</a>

          {#if loggedIn}
<!--            <div class="flex flex-col gap-1 ml-4">-->
<!--              {#each categories as category}-->
<!--                  {#if isAdmin || category.category_id <= progress}-->
<!--                      <a href="/#/questionnaire/{category.category_id}" on:click={() => navigateTo(`/#/questionnaire/${category.category_id}`)}>{category.category_name}</a>-->
<!--                  {/if}-->
<!--              {/each}-->
<!--            </div>-->

              {#if isAdmin || progress >= categories.length}
                  <a href="/#/answers" class="text-lg font-semibold" on:click={() => navigateTo("/#/answers")}>Antworten</a>
                  <a href="/#/results" class="text-lg font-semibold" on:click={() => navigateTo("/#/results")}>Ergebnisse</a>
              {/if}

              {#if isAdmin}
                  <a href="/#/admin" class="text-lg font-semibold" on:click={() => navigateTo("/#/admin")}>Admin</a>
              {/if}

              <a href="/#/" on:click={() => { handleLogout(); navigateTo('/#/'); }} class="bg-secondary hover:bg-secondary-hover text-secondary-text rounded-full p-2 px-4 flex items-center justify-center">Logout</a>
          {/if}
      </div>
  </div>
  <div class="overlay z-20 h-screen w-screen" in:fade out:fade on:click={() => sidebarVisible = false} on:keydown={handleKeyDown} aria-label="Close Sidebar" role="presentation" />
</div>
{/if}

<style>
  .overlay {
      background-color: rgba(0, 0, 0, 0.5);
  }
</style>
